import { Link } from 'react-router-dom'
import { TEXTOS } from '../../../lib/glossario'
import type { ChamadoForaDaApuracao } from '../../../types/chamado'

/**
 * Os chamados que o fiscal tirou da apuração do mês, cada um com o motivo.
 *
 * Fora do número, mas não fora da tela. Antes da versão 1.2 do cálculo a caixa "este chamado entra
 * na apuração" era gravada e ignorada; agora ela tira o chamado de todo denominador — e sumir com ele
 * sem deixar rastro seria o mesmo defeito ao contrário: o mês perderia chamados sem ninguém ver por
 * quê. Cinza e não âmbar: não é pendência, é decisão já tomada.
 *
 * @param props os chamados excluídos
 * @returns a lista, ou nada quando não há exclusão
 */
export function ForaDaApuracao({ chamados }: { chamados: ChamadoForaDaApuracao[] | undefined }) {
  const t = TEXTOS.fiscalizacao.foraDaApuracao
  if (!chamados || chamados.length === 0) {
    return null
  }
  return (
    <section className="rounded-lg border border-slate-300 bg-slate-50 px-4 py-3">
      <h3 className="text-sm font-semibold text-slate-900">
        {t.titulo} ({chamados.length})
      </h3>
      <p className="mt-1 max-w-prose text-xs text-slate-600">{t.ajuda}</p>
      <ul className="mt-2 space-y-1">
        {chamados.map((chamado) => (
          <li key={chamado.idExterno} className="text-sm text-slate-700">
            <Link
              to={`/chamados/${chamado.id}`}
              className="tabular-nums text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
            >
              {chamado.idExterno}
            </Link>
            <span className="text-slate-600"> — {chamado.motivo ?? t.semMotivo}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
